import { SHOW_GIFT_CARD_MODAL, UPDATE_GIFT_CARD_CODE } from 'constants/reduxActions';

import { hasBadPromoCodeOrGiftCard } from 'helpers/CheckoutUtils';
import { fetchCheckoutData } from 'actions/checkout/purchase';

export function conditionallyCollapseGiftCardModal() {
  return function (dispatch, getState) {
    const {
      checkoutData: {
        purchaseData: {
          constraintViolations: cvs
        }
      }
    } = getState();

    if (hasBadPromoCodeOrGiftCard(cvs)) {
      return;
    }

    dispatch(showGiftCardModal(false));
  };
}

export function showGiftCardModal(visible) {
  return { type: SHOW_GIFT_CARD_MODAL, visible };
}

export function updateGiftCardCode(giftCardCode) {
  return { type: UPDATE_GIFT_CARD_CODE, giftCardCode };
}

export function verifyGiftCard(code, mafiaEndpoints) {
  return function (dispatch) {
    dispatch(fetchCheckoutData({ coupon: code, showFullPageSpinner: false }, mafiaEndpoints));
  };
}
